import type { Language, User } from "@lyteflo/types";
import { getDealerContextStore, initializeProfileStore } from "@lyteflo/utils";
import {
  clearAmplitudeUserIdentity,
  setAmplitudeUserIdentity,
} from "@services/analytics";

import i18n from "../translations/i18n";

export const initPortalWebProfileStore = () => {
  initializeProfileStore(window.localStorage, {
    onProfileSet: (user: User) => {
      setAmplitudeUserIdentity(user);
    },
    onProfileClear: () => {
      getDealerContextStore().resetContext();
      clearAmplitudeUserIdentity();
    },
    onLanguageChange: async (language: Language) => {
      await i18n.changeLanguage(language);
      try {
        window.localStorage.setItem("lf_language", language);
      } catch (_) {
        console.error("Failed to set language in local storage");
      }
    },
  });
};
